// extracted by mini-css-extract-plugin
export var csatScore = "_k8-5";
export var header = "_k8-1";
export var panelWrapper = "_k8-2";
export var postPreview = "_k8-3";
export var rightContent = "_k8-0";
export var wrappingText = "_k8-4";